import { createApp } from 'vue';
import App from './App.vue';
import './assets/styles.css';
import { FontAwesomeIcon } from './config/font-awesome';
import router from './router';

const app = createApp(App);

app.component('font-awesome-icon', FontAwesomeIcon);
app.use(router);
app.mount('#app');
